import protoRoot from "../proto-root";
import createMessage from "./createMessage";

function create(payload) {
  const PairingType = protoRoot.lookupEnum("comm.PairingType");
  const PairingSource = protoRoot.lookupEnum("comm.PairingSource");

  payload.pairingType = PairingType.values[payload.pairingType];
  payload.pairingSource = PairingSource.values[payload.pairingSource];

  const RequestPairingMessage = protoRoot.lookupType(
    `comm.RequestPairingMessage`
  );
  const requestPairingMessage = RequestPairingMessage.create(payload);

  return createMessage({ requestPairingMessage });
}

export default {
  create
};
